// Copy-pasted from Nirvana repo
class HtmlEscapeUtilsImpl {
    #escapeEntitiesMap = {
        '&amp;': '&',
        '&gt;': '>',
        '&lt;': '<',
        '&quot;': '"',
        '&#39;': "'",
    };
    #charToEntity = {};
    #entityToChar = {};
    #charToEntityRegex;
    #entityToCharRegex;

    constructor() {
        this.#init();
    }

    /**
     * Convert certain characters (&, <, >, ', and ") to their HTML character equivalents for literal display in web pages.
     * @param {string} value The string to encode.
     * @return {string} The encoded text.
     * @method
     */
    htmlEncode(value) {
        return !value ? value : String(value).replace(this.#charToEntityRegex, this.#htmlEncodeReplaceFn.bind(this));
    }

    /**
     * Convert certain characters (&, <, >, ', and ") from their HTML character equivalents.
     * @param {string} value The string to decode.
     * @return {string} The decoded text.
     * @method
     */
    htmlDecode(value) {
        return !value ? value : String(value).replace(this.#entityToCharRegex, this.#htmlDecodeReplaceFn.bind(this));
    }

    /**
     * Checks if a string has values needing to be html encoded.
     * @private
     * @param {String} s The string to test
     * @return {Boolean} `true` if the string contains HTML characters
     */
    hasHtmlCharacters(s) {
        return this.#charToEntityRegex.test(s);
    }

    #htmlEncodeReplaceFn(_, capture) {
        return this.#charToEntity[capture];
    }

    #htmlDecodeReplaceFn(_, capture) {
        return capture in this.#entityToChar
            ? this.#entityToChar[capture]
            : String.fromCharCode(parseInt(capture.substr(2), 10));
    }

    #init() {
        const charKeys = [],
            entityKeys = [];
        let key, escapedChar;
        for (key in this.#escapeEntitiesMap) {
            if (!this.#escapeEntitiesMap.hasOwnProperty(key)) {
                continue;
            }
            escapedChar = this.#escapeEntitiesMap[key];
            this.#entityToChar[key] = escapedChar;
            this.#charToEntity[escapedChar] = key;
            charKeys.push(escapedChar);
            entityKeys.push(key);
        }
        this.#charToEntityRegex = new RegExp('(' + charKeys.join('|') + ')', 'g');
        this.#entityToCharRegex = new RegExp('(' + entityKeys.join('|') + '|&#[0-9]{1,5};' + ')', 'g');
    }
}

export const HtmlEscapeUtils = new HtmlEscapeUtilsImpl();